// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j8wO","type":"styles_type__2vKmp","choices":"styles_choices__2tfx8"};